export default __webpack_public_path__ + "media/samples/FUNDEMANTALS_02-b3f871c3.jpg";